
// getLanguage gets the current application language in short string format (like "en", "de", ...)
function getDefaultLanguage() {
    let lang = document.cookie.match("lang=(.*?)([;\s]|$)")
    if (lang != null && lang[1]){
        return lang[1]
    }
    return navigator.language || navigator.userLanguage || "en"
}

// applyMessages sets the messages to be used by the window.Messages() function
function applyMessages(messages){
    window.Messages = function(resId, ...replace){
        let rawResult = messages[resId] != null ? messages[resId] : resId
        let formattedResult = rawResult

        if (replace && replace.length > 0) {
            for (var i = 0; i < replace.length; i++) {
                formattedResult = formattedResult.replace("{" + i + "}", replace[i])
            }
        }

        return formattedResult
    }
    if (messages["app.title"])
    {
        document.title = messages["app.title"];
    }
}

// textMessageToString formats a TextMessage (Java class / JS Object) to a string 
function textMessageToString(msg) {
    const args = msg.args.map(a => typeof a === "object" ? textMessageToString(a) : a)
    return Messages.apply(null, [msg.messageId].concat(args))
}

export { getDefaultLanguage, applyMessages, textMessageToString }
